import React from "react";
import Select, { StylesConfig } from "react-select";
import { ISelectOptionDTO } from "@hooks/dtos/forms/ISelectDTO";

interface IProps {
  label?: string;
  options?: ISelectOptionDTO[];
  value?: string | number | Array<string | number>;
  onChange?: (value: string | number | Array<string | number>) => void;
  placeholder?: string;
  errorMessage?: string;
  isDisabled?: boolean;
  isMulti?: boolean;
}

const customStyles: StylesConfig<any, boolean> = {
  option: (provided, state) => ({
    ...provided,
    padding: "10px 15px",
    backgroundColor: state.isSelected
      ? "#007bff"
      : state.isFocused
      ? "#f8f9fa"
      : "white",
    color: state.isSelected ? "white" : "#212529",
    "&:active": {
      backgroundColor: "#007bff",
      color: "white",
    },
  }),
  control: (provided) => ({
    ...provided,
    minHeight: "45px",
    borderColor: "#ced4da",
    "&:hover": {
      borderColor: "#ced4da",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    marginTop: "2px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
  }),
};

const formatOptionLabel = (option: ISelectOptionDTO) => (
  <div>
    <div className="fw-bold">{option.name}</div>
    {option.description && (
      <small className="text-muted" style={{ fontSize: "0.85em" }}>
        {option.description}
      </small>
    )}
  </div>
);

export function RichSelect({
  label,
  options = [],
  value,
  onChange,
  placeholder = "Selecione uma opção...",
  errorMessage,
  isDisabled = false,
  isMulti = false,
}: IProps) {
  const selectOptions = options.map((option) => ({
    ...option,
    label: option.name,
    value: option.value,
  }));

  const selectedValue = isMulti
    ? selectOptions.filter((option) =>
        Array.isArray(value) ? value.includes(option.value) : false,
      )
    : selectOptions.find((option) => option.value === value);

  const handleChange = (selectedOption: any) => {
    const nextValue = isMulti
      ? (selectedOption || []).map((option: ISelectOptionDTO) => option.value)
      : selectedOption?.value;

    onChange?.(nextValue);
  };

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label mb-2 d-block">{label}</label>
      )}

      <Select
        options={selectOptions}
        value={selectedValue ?? null}
        onChange={handleChange}
        placeholder={placeholder}
        formatOptionLabel={formatOptionLabel}
        styles={customStyles}
        isMulti={isMulti}
        isDisabled={isDisabled}
        isSearchable={true}
        className={errorMessage ? "is-invalid" : ""}
        classNamePrefix="select"
        menuPlacement="auto"
        menuShouldScrollIntoView={true}
      />

      {errorMessage && (
        <div className="invalid-feedback d-block">{errorMessage}</div>
      )}
    </div>
  );
}
